/**
 * Adzuki.my_shortcuts
 */
(function MyShortcuts($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		// open the task manager top menu
		$('.my-shortcuts-link a').on('click', _openMyShortcutsTopMenu);

		// closing the task manager top menu
		$('.ms-close').on('click', _closeMyShortcutsTopMenu);
	});

	function _loadShortcuts()
	{
		Adzuki.Ajax.get('/Shortcuts/topView')
			.then(function populateShortcuts(response) {
				$('.shortcuts-container').html(response);
				$('.shortcuts-loader').addClass('hidden');
			}
		);
	}

	function _loadAddLinkForm()
	{
		Adzuki.Ajax.get('/Shortcuts/shortcutAddLink')
			.then(function populateShortcuts(response) {
				$('.add-link-container').html(response);
				Adzuki.Form.initAjaxForm('ShortcutAddLink');
			}
		);
	}

	function _openMyShortcutsTopMenu(e)
	{
		// handle task manager icon click
		e.preventDefault();

		// load shortcuts
		_loadShortcuts();
		_loadAddLinkForm();

		// if account messages are open, close it
		if ($('.account-messages-container').is(':visible')) {
			$('.account-messages-container').slideToggle('fast');
			$('.account-messages-link a').css('background-color', 'transparent');
		}

		// if quick actions is open, close it
		if ($('.quick-actions-container').is(':visible')) {
			$('.quick-actions-container').slideToggle('fast');
			$('.quick-actions-link a').css('background-color', 'transparent');
		}

		// if task manager is open, close it
		if ($('.task-manager-container').is(':visible')) {
			$('.task-manager-container').slideToggle('fast');
			$('.task-manager-link a').css('background-color', 'transparent');
		}

		// display my shortcuts
		$('.my-shortcuts-container').slideToggle('fast', function myShortcutsSlideToggle() {
			if ($('.my-shortcuts-container').is(':visible')) {
				$('.my-shortcuts-link a').css('background-color', 'rgba(0,0,0,0.2)');
			} else {
				$('.my-shortcuts-link a').css('background-color', 'transparent');
			}
		});
	}

	function _closeMyShortcutsTopMenu(e)
	{
		$('.my-shortcuts-container').slideToggle('fast');
		$('.my-shortcuts-link a').css('background-color', 'transparent');
	}

}(jQuery, window.Adzuki || {}));